/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRoadsideServiceCar48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <g stroke='currentColor' strokeWidth={1.5}>
        <path
          strokeMiterlimit={2}
          d='M33.6 21.6h1.954c.512 0 .926.414.926.926v3.268c0 .51-.414.926-.926.926H33.6V21.6z'
        />
        <path
          strokeMiterlimit={2}
          d='M33.6 44.64a5.28 5.28 0 100-10.56 5.28 5.28 0 000 10.56z'
        />
        <path strokeMiterlimit={1.5} d='M32.822 39.36h1.44' />
        <path d='M29.76 9.6a1.44 1.44 0 00-1.44-1.44h-.48A1.44 1.44 0 0026.4 9.6V12h3.36V9.6z' />
        <path
          strokeMiterlimit={2}
          d='M38.518 39.688h6.398v-9.984c0-.548-.31-1.048-.802-1.292-2.068-1.018-7.41-3.654-7.41-3.654'
        />
        <path d='M37.44 36h7.2' />
        <path strokeMiterlimit={2} d='M22.898 24.048v15.64H28.8' />
        <path
          strokeMiterlimit={2}
          d='M36.108 22.01L34.56 12H22.898v12.048M-1.44 39.688h24'
        />
        <path
          strokeMiterlimit={5}
          d='M-17.76 39.688v-8.53l35.704-.036a1.721 1.721 0 011.72 1.718v1.968a1.72 1.72 0 01-1.72 1.718H.96'
        />
        <path
          strokeLinecap='square'
          strokeMiterlimit={5}
          d='M-20.16 27.384v-5.222c0-.94.41-1.834 1.124-2.446l3.568-3.06v-1.804a4.897 4.897 0 014.898-4.896H.606a2.6 2.6 0 012.132 1.11l3.916 5.59 9.9 2.532a2.88 2.88 0 012.166 2.79v5.35l-38.88.056z'
        />
        <path
          strokeMiterlimit={5}
          d='M13.92 22.08l4.8 1.44M-16.138 16.66H6.654'
        />
        <path
          fill='#fff'
          strokeLinejoin='round'
          strokeMiterlimit={5}
          d='M7.062 30.68a3.352 3.352 0 100-6.704 3.352 3.352 0 000 6.704z'
        />
        <path d='M34.56 14.88h-8.64v10.07h5.28' />
      </g>
      <defs>
        <clipPath id='roadside-service-car-48_svg__clip0'>
          <path fill='#fff' d='M0 0h48v48H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgRoadsideServiceCar48;
